var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.518,94.909H193.885v-10.37c0-22.908-18.574-41.482-41.482-41.482H48.699  c-22.908,0-41.482,18.574-41.482,41.482v51.852v72.593v217.78c0,22.907,18.574,41.482,41.482,41.482h414.819  c22.908,0,41.482-18.575,41.482-41.482V136.391C505,113.483,486.426,94.909,463.518,94.909z M27.958,84.539  c0-11.435,9.308-20.741,20.741-20.741h103.705c11.433,0,20.741,9.306,20.741,20.741v10.37v20.741h20.741h269.633  c11.433,0,20.741,9.306,20.741,20.741v20.741H27.958v-20.741V84.539z M463.518,447.506H48.699c-11.433,0-20.741-9.307-20.741-20.741  v-217.78v-31.111h456.301v248.892C484.259,438.198,474.952,447.506,463.518,447.506z",
    fill: "#37404D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericFile);
export default __webpack_public_path__ + "static/media/generic_file.6b31cbca35ae85abbb90acdfd64e3cd3.svg";
export { ForwardRef as ReactComponent };